import React, { useEffect, useState, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { notificationManager } from '../../../../../utils/NotificationUtils';
import {
  IN_ROOM_DINING_CUSTOMISATIONS_CREATE,
  IN_ROOM_DINING_CUSTOMISATIONS_VIEW,
  IN_ROOM_DINING_SELECTED_ITEM_ALREADY_OCCUPIED_ERROR,
} from '../../../../../constants/InRoomDiningConst';
import {
  RBAC_PERMISSION_LEVEL_FULL_ACCESS,
  RBAC_TYPE_SERVICES_IN_ROOM_DINING,
} from '../../../../../constants/RoleConsts';
import LinearProgressBar from '../../../../../shared/progress-bar/Progress';
import SearchBar from '../../../../../shared/search-bar/Search-Bar';
import {
  fetchAllInRoomDining,
  inRoomDiningCustomisationsSelector,
  inRoomDiningItemsSelector,
  setInRoomDiningCustomisations,
} from '../../../servicesSlice';
import InRoomDiningCustomisationTable from './Customisation-Table';
import {
  activateInRoomDiningCustomisation,
  deactivateInRoomDiningCustomisation,
  deleteInRoomDiningCustomisation,
  deleteSelectedItems,
  updateSelectedItemsStatus,
  uploadIRDCustomizationsByCSV,
  addInRoomDiningCustomisation,
} from '../../../../../utils/ServicesAPIUtils';
import DeletePopupModel from '../../../../../shared/delete-popup/Delete-Popup';
import WarningPopup from '../../../../../shared/warning-popup/Warning-Popup';
import useOutsideAlerter from '../../../../../custom-hooks/useOutsideAlerter';
import { createDataSortMapping } from '../../../../../utils/PropertyAPIUtils';
import {
  getCheckedIds,
  updateCheckedStatus,
  validateAlphanumeric,
  generateConfirmationMessage,
  selectedCheckList,
  ResetFilterList,
  isDragDisabled,
} from '../../../../../utils/formUtils';
import { Dialog } from '@mui/material';
import CsvUploader from '../../../../../shared/csv-uploader/Csv-Uploader';
import { allHotelsSelector } from '../../../../property/propertySlice';
import MultipleDeleteConfirmationPopup from '../../../../../shared/MultiActionPopUp/MultiDeleteConfirmationPopup';
import MultipleSelectionAlert from '../../../../../shared/MultiActionPopUp/MultipleSelectionAlert';
import { decryptLocalStorage } from '../../../../../utils/authUtils';
import { DOWNLOAD_ASSETS_URL } from '../../../../../env/Configurations';
import { stepDownLoaderCount, stepUpLoaderCount } from '../../../../../utils/loaderSlice';

const initialState = {
  name: '',
  description: '',
  status: false,
};

const InRoomDiningCustomisationList = (props) => {
  const {
    onDrawerToggle,
    onViewToggle,
    hotelId,
    restaurantId,
    inRoomDiningLoader,
    permissions,
    page,
    rowsPerPage,
    onsetRowsPerPage,
    onsetPage,
    isHideAddButton = false,
  } = props;
  const inRoomDiningCustomisations = useSelector(inRoomDiningCustomisationsSelector);
  const selectedHotel = useSelector(allHotelsSelector);
  const [customisation, setCustomisation] = useState([]);
  const [selectedValue, setSelectedValue] = useState({
    id: '',
    name: '',
    title: '',
    description: '',
    status: false,
    anchorEl: null,
  });
  const inRoomDiningItems = useSelector(inRoomDiningItemsSelector);
  const dispatch = useDispatch();
  const [warningPopup, setWarningPopup] = useState(initialState);
  const [visible, setVisible] = useState(false);
  const wrapperRef = useRef(null);
  const prevHotelIdRef = useRef(hotelId);
  const [popUp, setPopUp] = useState(false);
  const [searchText, setSearchText] = useState('');
  const [uploadState, setUploadState] = useState(false);
  const [csvUploadStatus, setCsvUploadStatus] = useState(false);
  const [csvUploadErrorMsg, setCsvUploadErrorMsg] = useState(null);
  const [csvValidateError, setCsvValidateError] = useState(false);
  const [dataExistError, setDataExistError] = useState(false);
  const [validationErrors, setValidationErrors] = useState([]);
  const [isAllSelected, setIsAllSelected] = useState(false);
  const [actionMenuList, setActionMenuList] = useState([]);
  const [actionName, setActionName] = useState(false);
  const [isActive, setIsActive] = useState(false);
  const [showMultipleDeleteConfirmation, setShowMultipleDeleteConfirmation] = useState(false);
  const [showBulkActiveDeactiveConfirmation, setShowBulkActiveDeactiveConfirmation] =
    useState(false);
  const [showBulkSearchAlert, setShowBulkSearchAlert] = useState(false);
  const [showBulkKebabSelectionAlert, setShowBulkKebabSelectionAlert] = useState(false);
  const [showBulkFilterAlert, setShowBulkFilterAlert] = useState(false);

  useEffect(() => {
    setCustomisation((prevList) => {
      return inRoomDiningCustomisations?.map((item) => {
        const isChecked = selectedCheckList(prevList, item.id);
        return {
          ...item,
          isChecked: isChecked,
        };
      });
    });
    setSearchText('');
  }, [inRoomDiningCustomisations]);

  useEffect(() => {
    if (inRoomDiningLoader || customisation?.length === 0) return;
    const totalItems = customisation?.length;
    const maxPageIndex = Math.max(Math.ceil(totalItems / rowsPerPage) - 1, 0);
    if (page > maxPageIndex) {
      onsetPage(maxPageIndex);
    }
  }, [customisation?.length, rowsPerPage, page, onsetPage]);

  useEffect(() => {
    if (prevHotelIdRef?.current !== hotelId) {
      onsetPage(0);
    }
    prevHotelIdRef.current = hotelId;
  }, [hotelId]);

  const handleSearchText = async (searchText) => {
    setSearchText(searchText);
    const checkedIdList = getCheckedIds(customisation, 'isChecked');
    const filteredRows = await inRoomDiningCustomisations.filter((item) => {
      return item.name.toLowerCase().includes(searchText.toLowerCase());
    });
    onsetPage(0);
    const updatedCheckedList = updateCheckedStatus(filteredRows, checkedIdList);
    setCustomisation(updatedCheckedList);
    if (searchText && (isAllSelected || selectedCustomisationLength > 0)) {
      setShowBulkSearchAlert(true);
    } else if (!searchText) {
      setShowBulkSearchAlert(false);
      setCustomisation(ResetFilterList);
    }
  };

  const getCheckedCustomisationList = customisation?.filter((custom) => custom?.isChecked);

  const dragDisabled = isDragDisabled(customisation, searchText);

  const listOfCustomisationIds = getCheckedCustomisationList?.map((custom) => custom?.id);

  const selectedCustomisationLength = getCheckedCustomisationList?.length;

  const onOpenDrawer = (event, type) => {
    if (selectedCustomisationLength) {
      setCustomisation(ResetFilterList);
    }
    event.stopPropagation();
    onDrawerToggle(type, true, selectedValue.customisation);
    handleClose();
  };

  const handleClose = () => {
    setSelectedValue({
      id: '',
      name: '',
      title: '',
      description: '',
      status: false,
      anchorEl: null,
      customisation: null,
    });
  };

  const onViewDetails = () => {
    onViewToggle(IN_ROOM_DINING_CUSTOMISATIONS_VIEW, true, selectedValue.customisation);
  };

  const onClickRowViewDetails = (customisationItem, e) => {
    if (e?.target?.tagName === 'TD') {
      onViewToggle(IN_ROOM_DINING_CUSTOMISATIONS_VIEW, true, customisationItem);
    }
  };

  const handleCellMenuClick = (event, customisationData) => {
    event.stopPropagation();
    if (selectedCustomisationLength > 1) {
      setShowBulkKebabSelectionAlert(true);
    } else {
      setSelectedValue({
        id: customisationData.id,
        name: '',
        title: '',
        description: '',
        status: false,
        anchorEl: event.currentTarget,
        customisation: customisationData,
      });
    }
  };

  const handleBulkSearchAlertClose = () => {
    setShowBulkSearchAlert(false);
    setSearchText('');
    setCustomisation(
      inRoomDiningCustomisations.map((res) => ({
        ...res,
        isChecked: false,
      })),
    );
  };

  const handleChangePage = (event, newPage) => {
    onsetPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    onsetRowsPerPage(parseInt(event.target.value, 10));
    onsetPage(0);
  };

  const onActiveDeActiveonDeleteCustomisation = async (e, type) => {
    try {
      e.stopPropagation();
      dispatch(stepUpLoaderCount());
      const selectedLanguage = decryptLocalStorage('lang');
      const language = selectedLanguage !== 'en' ? selectedLanguage : '';
      if (type === 'deactivate') {
        await deactivateInRoomDiningCustomisation(
          selectedValue.id,
          hotelId,
          restaurantId,
          language,
        );
      } else {
        await activateInRoomDiningCustomisation(selectedValue.id, hotelId, restaurantId, language);
      }
      dispatch(fetchAllInRoomDining(hotelId, restaurantId));
      notificationManager(
        'success',
        `Customisation ${type === 'deactivate' ? 'deactivated' : 'activated'} successfully`,
      );
      handleClose();
    } catch (e) {
      notificationManager(
        'danger',
        e.graphQLErrors ? e.graphQLErrors[0].message : `Customisation not ${type}`,
      );
      handleClose();
    } finally {
      dispatch(stepDownLoaderCount());
    }
    setIsAllSelected(false);
    setActionMenuList([]);
  };

  const checkUsageItems = () => {
    return inRoomDiningItems.some(
      (ird) =>
        ird.customisation.ingredients &&
        ird.customisation.ingredients.some((item) =>
          item.customisations.some((customisationItem) => customisationItem === selectedValue.id),
        ),
    );
  };

  const onDelete = async () => {
    try {
      dispatch(stepUpLoaderCount());
      if (selectedValue && selectedValue?.id) {
        const selectedLanguage = decryptLocalStorage('lang');
        const language = selectedLanguage !== 'en' ? selectedLanguage : '';
        await deleteInRoomDiningCustomisation(selectedValue.id, hotelId, restaurantId, language);
        dispatch(fetchAllInRoomDining(hotelId, restaurantId));
        notificationManager('success', 'Customisation deleted successfully');
      }
    } catch (e) {
      if (e.graphQLErrors) {
        switch (e.graphQLErrors[0].message) {
          case IN_ROOM_DINING_SELECTED_ITEM_ALREADY_OCCUPIED_ERROR:
            setWarningPopup({
              name: selectedValue.name,
              description:
                'The selected Customisation cannot be deleted as it is being added to a Menu/Item',
              status: true,
            });
            break;
          default:
            notificationManager('danger', e.graphQLErrors[0].message);
            break;
        }
      } else {
        notificationManager('danger', 'Failed to delete Customisation');
      }
    } finally {
      dispatch(stepDownLoaderCount());
    }
    handleClose();
    setIsAllSelected(false);
    setActionMenuList([]);
  };

  const onDeleteCustomisation = (event) => {
    event.stopPropagation();
    if (checkUsageItems()) {
      setWarningPopup({
        name: selectedValue.name,
        description:
          'The selected Customisation cannot be deleted as it is being added to a Menu/Item',
        status: true,
      });
    } else {
      setSelectedValue((prev) => ({
        ...prev,
        title: 'Are you sure you want to delete',
        name: prev.customisation.name,
        description: 'This action cannot be reversed',
        status: true,
        anchorEl: null,
      }));
    }
  };

  const onDeleteCancel = () => {
    handleClose();
  };

  const onCloseWarning = () => {
    handleClose();
    setWarningPopup(initialState);
  };

  useOutsideAlerter(wrapperRef, visible, setPopUp);

  const handleUploadDialogClose = (e) => {
    dispatch(fetchAllInRoomDining(hotelId, restaurantId));
    setCsvUploadStatus(null);
    setUploadState(false);
  };
  const onClickUpload = (e) => {
    setUploadState(true);
  };

  const isValidStatus = (status) => {
    const tempStatus = status.toLowerCase().trim();
    return tempStatus === 'yes' || tempStatus === 'no';
  };

  const handleCsvFileData = (itemsLists) => {
    const isTemplateInstructionRow = (row) => {
      const values = Object.values(row).map((v) => String(v || '').toLowerCase().trim());
      const joined = values.join(' ');
      const instructionPatterns = [
        'character limit', 'mandatory', 'alphanumeric', 'alpha-numeric',
        'enter the', 'fill in', 'e.g.', 'example:', 'max characters',
        'max char', 'required field', 'this field', 'drop down', 'dropdown',
        'select from', 'free text', 'auto populate', 'auto-populate',
      ];
      if (values.some((s) => s.startsWith('*') && instructionPatterns.some((p) => s.includes(p)))) return true;
      if (instructionPatterns.filter((p) => joined.includes(p)).length >= 2) return true;
      return false;
    };
    const filteredItemList = itemsLists.filter((row) => !isTemplateInstructionRow(row));
    const errors = [];
    if (filteredItemList.length === 0) {
      errors.push('No data rows found in the uploaded file.');
      setValidationErrors(errors);
      setCsvValidateError(true);
      return;
    }
    filteredItemList.forEach((item) => {
      const rowNum = item.__rowNum || '?';
      const rowErrors = [];
      if (!item.customizationName?.trim()) {
        rowErrors.push('"Customization Name" is empty');
      } else {
        if (item.customizationName.trim().length > 100) rowErrors.push('"Customization Name" exceeds 100 characters');
      }
      if (!item.customizationCode?.trim()) {
        rowErrors.push('"Customization Code" is empty');
      } else {
        if (item.customizationCode.trim().length > 60) rowErrors.push('"Customization Code" exceeds 60 characters');
        if (!validateAlphanumeric(item.customizationCode.trim())) rowErrors.push('"Customization Code" must be alphanumeric');
      }
      if (item.active?.trim() && !isValidStatus(item.active)) rowErrors.push('"Active" must be Yes or No');
      if (rowErrors.length > 0) errors.push(`Row ${rowNum}: ${rowErrors.join(', ')}`);
    });
    if (errors.length > 0) {
      setValidationErrors(errors);
      setCsvValidateError(true);
      return;
    }
    const duplicateErrors = [];
    const newItems = filteredItemList.filter((item) => {
      const nameExists = customisation.findIndex((ch) => ch?.name?.trim()?.toLowerCase() === item?.customizationName?.trim()?.toLowerCase()) > -1;
      const codeExists = customisation.findIndex((ch) => ch?.code?.trim()?.toLowerCase() === item?.customizationCode?.trim()?.toLowerCase()) > -1;
      if (nameExists || codeExists) {
        const rowNum = item.__rowNum || '?';
        const reasons = [];
        if (nameExists) reasons.push(`name '${item.customizationName.trim()}'`);
        if (codeExists) reasons.push(`code '${item.customizationCode.trim()}'`);
        duplicateErrors.push(`Row ${rowNum}: Already exists (${reasons.join(' and ')})`);
        return false;
      }
      return true;
    });
    if (duplicateErrors.length > 0) duplicateErrors.forEach((e) => errors.push(e));
    if (newItems.length > 0) {
      const listToUpload = newItems.map((item) => ({
        hotelId,
        code: item?.customizationCode,
        name: item?.customizationName,
        status: item?.active?.trim()?.toUpperCase() === 'YES' ? true : false,
        restaurantId,
      }));
      setValidationErrors([]);
      setCsvValidateError(false);
      handleCsvDataSubmit(listToUpload);
    } else {
      setValidationErrors(errors);
      setCsvValidateError(true);
      setDataExistError(duplicateErrors.length > 0);
    }
  };

  const handleCsvDataSubmit = async (payloadLists) => {
    setCsvUploadStatus('uploading');
    try {
      dispatch(stepUpLoaderCount());
      const selectedLanguage = decryptLocalStorage('lang');
      const language = selectedLanguage !== 'en' ? selectedLanguage : '';

      for (const payload of payloadLists) {
        const individualPayload = {
          ...payload,
          customAttributes: [],
        };
        await addInRoomDiningCustomisation(individualPayload, language);
      }

      setCsvUploadStatus('success');
    } catch (e) {
      setCsvUploadErrorMsg(null);
      setCsvUploadStatus('server-error');
    } finally {
      dispatch(stepDownLoaderCount());
    }
  };

  const generateHeaders = [
    { label: 'Customization Name', key: 'name' },
    { label: 'Customization Code', key: 'code' },
    { label: 'Active', key: 'active' },
  ];

  const generateExportData = (itemsData) => {
    let tempList = itemsData?.map((e) => {
      return {
        ...e,
        active: e?.status ? 'YES' : 'NO',
      };
    });
    const fields = ['name', 'code', 'active'];
    return tempList.map((record) =>
      Object.fromEntries(
        Object?.entries(record)?.filter(([key, value]) =>
          fields?.includes(key) ? [key, "'" + value] : null,
        ),
      ),
    );
  };

  const handleExport = () => {
    let selectedValue = customisation?.filter((customisation) => customisation?.isChecked);
    let exportData = [];
    let csvName = '';

    const propertyName = selectedHotel?.find((value) => value?.id === hotelId)?.name;

    if (selectedValue?.length === 1) {
      csvName = `${selectedValue[0].name}_ird_customisation.csv`;
      exportData = generateExportData(selectedValue);
    } else if (selectedValue?.length > 1) {
      csvName = `${propertyName}_ird_customisations.csv`;
      exportData = generateExportData(selectedValue);
    } else {
      csvName = `${propertyName}_ird_customisations.csv`;
      exportData = generateExportData(customisation);
    }

    const headers = generateHeaders?.map((header) => header?.label);
    const csvContent = [
      headers.join(','),
      ...exportData?.map((item) =>
        generateHeaders?.map((header) => item[header.key] || '').join(','),
      ),
    ].join('\n');

    const blob = new Blob([csvContent], { type: 'text/csv' });
    const anchor = document.createElement('a');
    anchor.href = window.URL.createObjectURL(blob);
    anchor.download = csvName;

    document.body.appendChild(anchor);
    anchor.click();
    document.body.removeChild(anchor);
  };

  const handleAction = (actionName) => {
    let selectedcustomisation = customisation?.filter((customisation) => customisation?.isChecked);
    switch (actionName) {
      case 'Delete':
        if (selectedcustomisation?.length > 0) {
          setShowMultipleDeleteConfirmation(true);
          setActionName('delete');
        }
        break;
      case 'Activate':
        if (selectedcustomisation?.length > 0) {
          setShowBulkActiveDeactiveConfirmation(true);
          setActionName('activate');
          setIsActive(true);
        }
        break;
      case 'Deactivate':
        if (selectedcustomisation?.length > 0) {
          setShowBulkActiveDeactiveConfirmation(true);
          setActionName('deactivate');
          setIsActive(false);
        }
        break;
      case 'Export':
        if (selectedcustomisation?.length > 0) {
          handleExport();
        }
        break;
      default:
        break;
    }
  };

  const handleCheckboxChange = (id) => {
    let actionListName = [];
    let index = customisation?.findIndex((item) => item.id === id);
    if (!customisation[index]?.isChecked) {
      customisation[index] = { ...customisation[index], isChecked: true };
    } else {
      customisation[index].isChecked = !customisation[index]?.isChecked;
    }
    setCustomisation([...customisation]);

    let actionList = customisation
      ?.filter((customisation) => customisation?.isChecked)
      .map((status) => status?.status);

    const checkedItems = customisation?.filter((customisation) => customisation?.isChecked);

    if (checkedItems.length === 0) {
      setActionMenuList([]);
      setIsAllSelected(false);
      return;
    }

    const isActiveSelected = actionList.includes(true);
    const isInactiveSelected = actionList.includes(false);

    if (isActiveSelected && isInactiveSelected) {
      actionListName.push('Activate', 'Deactivate');
    } else if (isActiveSelected) {
      actionListName.push('Deactivate');
    } else if (isInactiveSelected) {
      actionListName.push('Activate');
    }
    if (!actionListName.includes('Export')) {
      actionListName.push('Export');
    }

    const isAllSelected = customisation?.every((item) => item?.isChecked);
    setIsAllSelected(isAllSelected);

    setActionMenuList(actionListName);
  };

  const handleSelectAll = (event) => {
    let actionListName = [];
    const CheckedValue = event?.target?.checked;
    setIsAllSelected(CheckedValue);
    let selectedcustomisationList = customisation?.map((item) => {
      return {
        ...item,
        isChecked: CheckedValue,
      };
    });

    const isActive = selectedcustomisationList?.some((customisation) => customisation?.status);
    const isInactive = selectedcustomisationList?.some((customisation) => !customisation.status);

    if (isActive && !actionListName?.includes('Deactivate')) {
      actionListName.push('Deactivate');
    }
    if (isInactive && !actionListName?.includes('Activate')) {
      actionListName.push('Activate');
    }
    if (!actionListName.includes('Export')) {
      actionListName.push('Export');
    }

    setCustomisation([...selectedcustomisationList]);

    const sortActionMenuList = actionListName.sort((a, b) => {
      const order = { Activate: 1, Deactivate: 2, Delete: 3 };
      return order[a] - order[b];
    });

    setActionMenuList(sortActionMenuList);

    if (!event?.target?.checked && !selectedcustomisationList.some((item) => item?.isChecked)) {
      setActionMenuList([]);
    }
  };

  const onApiCallConfirmationNotification = generateConfirmationMessage(
    'Customisation',
    listOfCustomisationIds?.length,
    isActive,
  );

  const handleMultipleStatusChange = async () => {
    handleClose();
    setActionMenuList([]);
    try {
      dispatch(stepUpLoaderCount());
      const lang = decryptLocalStorage('lang');
      const selectedLang = lang !== 'en' ? lang : '';
      const moduleName = 'IRD_CUSTOMISATION';
      await updateSelectedItemsStatus(
        listOfCustomisationIds,
        hotelId,
        selectedLang,
        moduleName,
        restaurantId,
        isActive,
        searchText.length > 0 ? false : isAllSelected,
      );
      dispatch(fetchAllInRoomDining(hotelId, restaurantId));
      notificationManager('success', onApiCallConfirmationNotification);
      setSelectedValue({
        id: '',
        name: '',
        title: '',
        description: '',
        status: false,
        activate: false,
        brand: null,
      });
    } catch (e) {
      notificationManager(
        'danger',
        e.graphQLErrors
          ? e.graphQLErrors[0].message
          : 'The status of the Customisation was not changed',
      );
    } finally {
      dispatch(stepDownLoaderCount());
    }
    setCustomisation(ResetFilterList);
    setIsAllSelected(false);
  };

  const deleteMultipleSelection = async () => {
    handleClose();
    try {
      const lang = decryptLocalStorage('lang');
      const selectedLang = lang !== 'en' ? lang : '';
      const moduleName = 'IRD_CUSTOMISATION';
      await deleteSelectedItems(
        listOfCustomisationIds,
        hotelId,
        selectedLang,
        moduleName,
        restaurantId,
        searchText.length > 0 ? false : isAllSelected,
      );
      dispatch(fetchAllInRoomDining(hotelId, restaurantId));
      notificationManager('success', 'Customisations Deleted Successfully');
      setSelectedValue({
        ...selectedValue,
        id: '',
        name: '',
        title: '',
        description: '',
        status: false,
        brand: null,
      });
    } catch (e) {
      notificationManager(
        'danger',
        e.graphQLErrors ? e.graphQLErrors[0].message : 'Failed to delete Customisation',
      );
    }
    setIsAllSelected(false);
  };

  return (
    <div className='mt-4 mb-4 group-list-container'>
      {warningPopup?.status && (
        <WarningPopup warningPopup={warningPopup} onWarningClose={onCloseWarning} />
      )}
      <Dialog fullScreen open={uploadState} onClose={handleUploadDialogClose}>
        <CsvUploader
          onClose={handleUploadDialogClose}
          pageTitle='Customizations'
          onFileReadingComplete={(e) => handleCsvFileData(e)}
          csvUploadStatus={csvUploadStatus}
          validFormatError={csvValidateError}
          setValidFormatError={setCsvValidateError}
          dataExistError={dataExistError}
          setDataExistError={setDataExistError}
          listName='Customizations'
          sectionTItle='Menu Configuration'
          csvUploadErrorMsg={csvUploadErrorMsg}
          validationErrors={validationErrors}
          setValidationErrors={setValidationErrors}
          downloadLink={DOWNLOAD_ASSETS_URL + '/cmsAssets/Menu+Configs+Customization.xlsx'}
        />
      </Dialog>
      <SearchBar
        type={IN_ROOM_DINING_CUSTOMISATIONS_CREATE}
        buttonName='Add Customisation'
        setSearchText={handleSearchText}
        onOpenDrawer={onOpenDrawer}
        displayAddOrEdit={
          permissions[RBAC_TYPE_SERVICES_IN_ROOM_DINING] === RBAC_PERMISSION_LEVEL_FULL_ACCESS
            ? !isHideAddButton
              ? 'show'
              : 'hide'
            : 'hide'
        }
        filterList={[]}
        visible={visible}
        setVisible={setVisible}
        popUp={popUp}
        setPopUp={setPopUp}
        placeHolder={customisation}
        setPlaceHolder={setCustomisation}
        globalPlaceHolder={inRoomDiningCustomisations}
        setGlobalPlaceHolder={setInRoomDiningCustomisations}
        dispatch={dispatch}
        mappingApi={createDataSortMapping}
        displayText='In-Room dining customisations'
        module='IRD_CUSTOMISATION'
        searchText={searchText}
        setSearch={setSearchText}
        extraSecondaryBtnDisplay={
          permissions[RBAC_TYPE_SERVICES_IN_ROOM_DINING] === RBAC_PERMISSION_LEVEL_FULL_ACCESS
        }
        extraSecondaryBtnText='Upload'
        onClickSecondaryBtn={onClickUpload}
        //temporary disable
        // exportBtn
        // exportBtnTitle="Export"
        // headers={generateHeaders}
        // exportData={generateExportData(customisation)}
        actionMenuItems={actionMenuList ?? []}
        handleAction={handleAction ?? false}
      />
      <div ref={wrapperRef} className='row mx-2 d-flex mt-4'>
        {inRoomDiningLoader && (
          <div className='pt-4 col-md-12'>
            <LinearProgressBar />
          </div>
        )}
        <InRoomDiningCustomisationTable
          page={page}
          dragDisabled={dragDisabled}
          rowsPerPage={rowsPerPage}
          onOpenDrawer={onOpenDrawer}
          onViewDetails={onViewDetails}
          onClickRowViewDetails={onClickRowViewDetails}
          selectedValue={selectedValue}
          handleClose={handleClose}
          handleCellMenuClick={handleCellMenuClick}
          customisations={customisation}
          setCustomisations={setCustomisation}
          permissions={permissions}
          handleChangePage={handleChangePage}
          handleChangeRowsPerPage={handleChangeRowsPerPage}
          onDeleteCustomisation={onDeleteCustomisation}
          onActiveDeActiveonDeleteCustomisation={onActiveDeActiveonDeleteCustomisation}
          setVisible={setVisible}
          searchText={searchText}
          handleSelectAll={handleSelectAll}
          handleCheckboxChange={handleCheckboxChange}
          isAllSelected={isAllSelected}
          setIsAllSelected={setIsAllSelected}
          setActionMenuList={setActionMenuList}
          selectedCustomisationLength={selectedCustomisationLength}
          inRoomDiningCustomisations={inRoomDiningCustomisations}
        />
      </div>
      {selectedValue.id && selectedValue.status === true && (
        <DeletePopupModel
          deletePopUp={selectedValue}
          onDelete={onDelete}
          onDeleteCancel={onDeleteCancel}
        />
      )}{' '}
      {showMultipleDeleteConfirmation && (
        <MultipleDeleteConfirmationPopup
          title={`Are you sure you want to ${actionName} this selection?`}
          subTitle={`A selection of ${selectedCustomisationLength} ${
            selectedCustomisationLength > 1 ? 'customisations' : 'customisation'
          } will be ${actionName}d. This Action is irreversible.`}
          isOpen={showMultipleDeleteConfirmation}
          onClose={() => setShowMultipleDeleteConfirmation(false)}
          onConfirm={() => {
            deleteMultipleSelection();
          }}
          leftButtonName={'Cancel'}
          rightButtonName={'Delete'}
        />
      )}
      {showBulkActiveDeactiveConfirmation && (
        <MultipleDeleteConfirmationPopup
          title={`Are you sure you want to ${actionName} this selection?`}
          subTitle={`A selection of ${selectedCustomisationLength}  ${
            selectedCustomisationLength > 1 ? 'customisations' : 'customisation'
          } will be ${actionName}d.`}
          isOpen={showBulkActiveDeactiveConfirmation}
          onClose={() => setShowBulkActiveDeactiveConfirmation(false)}
          onConfirm={() => {
            handleMultipleStatusChange();
          }}
          leftButtonName={'No'}
          rightButtonName={'Yes'}
        />
      )}
      {showBulkSearchAlert && (
        <MultipleSelectionAlert
          isOpen={showBulkSearchAlert}
          onClose={handleBulkSearchAlertClose}
          message="If you perform a search after making selections, the items you've selected will be lost."
          ButtonName='Cancel'
        />
      )}
      {showBulkKebabSelectionAlert && (
        <MultipleSelectionAlert
          isOpen={showBulkKebabSelectionAlert}
          onClose={() => setShowBulkKebabSelectionAlert(false)}
          message='Please select one item from the list that you want to edit.'
          centerButtonName='OK'
        />
      )}
    </div>
  );
};

export default InRoomDiningCustomisationList;
